import { ResizablePanel } from '@art-of-hospitality-solutions-llc/ui-kit/components/resizable';

/** Resizable settings pane; the divider to its left is the visual border. */
export default function EditorPanel({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ResizablePanel
      defaultSize={26}
      minSize={18}
      maxSize={40}
      className="h-full min-w-0"
    >
      {children}
    </ResizablePanel>
  );
}
